import { Popover, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react";
import { Fragment, useState } from "react";
import { getTrackBackground, Range } from "react-range";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  // createUserProgram,
  createHyperProgram,
} from "../../api/api";
// import ic_close from "../../assets/icons/ic_close.svg";
// import congrats from "../../assets/gifs/congrats.gif";
import { useAuthContext } from "../../context/AuthContext";
import {
  // BlackTextLinearGradient,
  // BlueLinearGradient,
  numberToWords,
} from "../../utils/Utils";
// import CustomDialog from "../basic/Dialog";
// import IconButton from "../basic/IconButton";
import "react-datepicker/dist/react-datepicker.css";
import { CuratingPlaylist } from "./CreateAccountDialog";
// import healthyLife from "../../assets/images/healthy_life.png";
import start from "../../assets/images/start.jpg";
import InstructionDialog from "../home/InstructionDialog";

export function Stepper({ maxStep, currentStep }) {
  const Indicator = ({ active, text, align }) => (
    <div className={`flex flex-col `}>
      <p
        className={`${
          active ? "text-white" : "text-new-gray"
        } flex flex-row items-center md:gap-auto  gap-1 text-xs md:text-base sm:-pt-1`}
      >
        <span>
          <Icon icon="mdi:tick" className="md:h-6 md:w-6" />
        </span>
        {text}
      </p>
      <div
        className={` rounded-full h-[10px] md:h-[20px] w-[10px] md:w-[20px] p-1 shadow-md shadow-black/20 drop-shadow-md ${
          active ? "bg-primary-orange" : "bg-new-gray"
        }`}
      ></div>
    </div>
  );

  return (
    <div className="w-full md:w-1/2 justify-center mt-10">
      <div className="relative flex items-center w-full">
        <div className=" absolute md:w-[480px] w-[240px] mr-12 md:mt-6 mt-4 bg-new-gray h-[1px] rounded-md flex items-center ">
          <div
            style={{
              width: `${(currentStep / maxStep) * 115}%`,
              // background: "linear-gradient(90deg, #34E130 0%, #30A1E1 95.95%)",
              transition: "width 100ms",
            }}
            className=" h-[1px] rounded-md bg-primary-orange"
          ></div>
        </div>
        <div className="absolute w-full  z-1 flex flex-row justify-between">
          <Indicator
            active={currentStep >= 0}
            align="start"
            text="FITNESS & GOALS"
          />
          <Indicator active={currentStep >= 1} align="center" text="JOURNEY" />
          <Indicator
            active={currentStep >= 2}
            align="end"
            text="Mobility Test"
          />
        </div>
      </div>
    </div>
  );
}

// export function Stepper({ maxStep, currentStep }) {
//   const Indicator = ({ active, text, align }) => (
//     <div className={`flex flex-col `}>
//       <p
//         className={`${
//           active ? "text-white" : "text-new-gray"
//         } flex flex-row items-center gap-3  text-xs md:text-base`}
//       >
//         <span>
//           <Icon icon="mdi:tick" className="md:h-6 md:w-6" />
//         </span>
//         {text}
//       </p>
//       <div
//         className={` rounded-full h-[10px] md:h-[20px] w-[10px] md:w-[20px] p-1 shadow-md shadow-black/20 drop-shadow-md ${
//           active ? "bg-primary-orange" : "bg-new-gray"
//         }`}
//       ></div>
//     </div>
//   );

//   return (
//     <div className="w-full md:w-1/2 justify-center mt-10">
//       <div className="relative flex items-center w-full">
//         <div className=" absolute w-5/6 mr-10  mt-6 bg-new-gray h-[1px] rounded-md flex items-center ">
//           <div
//             style={{
//               width: `${(currentStep / maxStep) * 100}%`,
//               // background: "linear-gradient(90deg, #34E130 0%, #30A1E1 95.95%)",
//               transition: "width 500ms",
//             }}
//             className=" h-[1px] rounded-md bg-primary-orange"
//           ></div>
//         </div>
//         <div className="absolute w-full  z-1 flex flex-row justify-between">
//           <Indicator active={currentStep >= 0} align="start" text="ABOUT YOU" />
//           <Indicator
//             active={currentStep >= 1}
//             align="center"
//             text="FITNESS & GOALS"
//           />
//           <Indicator active={currentStep >= 2} align="end" text="JOURNEY" />
//         </div>
//       </div>
//     </div>
//   );
// }

export function RegistrationStep1({
  describes,
  setDescribes,
  wasBackPressed,
  onClickNext,
  onClickBack,
}) {
  const list = [
    {
      title: "Lose Weight",
      value: "lose_weight",
      image: "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy%400.75x-8.png",
    },
    {
      title: "Get Fitter",
      value: "fitter_me",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/tabata.jpg",
    },
    {
      title: "Gain Strength",
      value: "gain_strength",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+7%400.75x-8.png",
    },
    {
      title: "Gain Flexibility",
      value: "flexibility",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+4%400.75x-8.png",
    },
    {
      title: "Beat the Stress",
      value: "stress_buster",
      image:
        "https://getactyvfitness.blob.core.windows.net/images/0.75x/Artboard+2+copy+6%400.75x-8.png",
    },
    {
      title: "Walk: Fitness for walkers",
      value: "walk",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/total.jpg",
    },
    {
      title: "Run: Fitness for Runners",
      value: "run",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/speed.jpg",
    },
    {
      title: "Cycle: Fitness for Cyclists",
      value: "cycle",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/play.jpg",
    },
    {
      title: "Football: Up my game",
      value: "football",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/football.jpg",
    },
    {
      title: "Basketball: Up my game",
      value: "basketball",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/basketball.jpg",
    },
    {
      title: "Tennis: Up my game",
      value: "tennis",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/tennis.jpg",
    },
    {
      title: "Cricket: Up my game",
      value: "cricket",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/cricket.jpg",
    },
    {
      title: "Badminton: Up my game",
      value: "badminton",
      image: "https://getactyvfitness.blob.core.windows.net/images/exercises/batmeton.jpg",
    },
  ];

  function Item({ title, image, selection, selectionIndex, onClick }) {
    return (
      <div
        className={`bg-[#181822] rounded-t-xl hover:cursor-pointer w-full h-full overflow`}
        onClick={onClick}
      >
        <div className="relative rounded-t-xl overflow">
          {selectionIndex > -1 && (
            <div className="absolute bg-[#FE654F99] w-full h-full flex justify-center items-center">
              <p className="text-6xl text-center text-white font-bold">
                {selectionIndex + 1}
              </p>
            </div>
          )}
          <img
            src={image}
            className="max-h-40 w-full object-cover rounded-t-xl"
          />
        </div>
        <p className={`p-2 text-white font-medium`}>{title}</p>
      </div>
    );
  }
  console.log("RENDING STEP 2");
  return (
    <Transition appear show={true}>
      <Transition.Child
        as={Fragment}
        enter="transform transition ease-in-out duration-300"
        enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leave="transform transition ease-in-out duration-300"
        leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
      >
        <div className={`w-full transform py-10`}>
          <p className="text-white text-xl">
            Select any 1 goal{" "}
            <span className="text-primary-orange font-bold">
              ({describes.length}/1 selected)
            </span>
          </p>
          <div className="mt-5 grid grid-cols-1 md:grid-cols-4 gap-5">
            {list.map((goal) => {
              return (
                <Item
                  {...goal}
                  selection={describes.includes(goal.value)}
                  selectionIndex={describes.indexOf(goal.value)}
                  onClick={() => {
                    if (describes.includes(goal.value)) {
                      let list = [];
                      describes.forEach((eid) => {
                        if (eid != goal.value) {
                          list.push(eid);
                        }
                      });
                      setDescribes([...list]);
                    } else {
                      if (describes.length > 0) {
                        toast("You have already selected one priorities");
                      } else {
                        setDescribes([...describes, goal.value]);
                      }
                    }
                  }}
                />
              );
            })}
          </div>
          <div className="flex justify-center space-x-10">
            {/* <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded border-[1px] border-customGray-700 px-5 py-4"
              onClick={() => {
                onClickBack();
              }}
            >
              GO BACK
            </div> */}
            <div className="flex flex-1" />
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-primary-purple px-5 py-4"
              onClick={async () => {
                if (describes.length != 1) {
                  toast("Please select one goals", { type: "error" });
                } else {
                  onClickNext();
                }
              }}
            >
              NEXT
            </div>
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
}

export function RegistrationStep2({
  answers,
  setAnswers,
  onClickNext,
  // onClickBack,
  injuries,
  otherInjuries,
  setOtherInjuries,
  setInjuries,
  workoutDuration,
  setWorkoutDuration,
  wasBackPressed,
}) {
  const questions = [
    {
      questionNormal: "How ",
      questionBold: "long have you been training/working out?",
      key: "workingOutFrom",
      options: [
        {
          value: "Not Started",
          key: 1,
        },
        {
          value: "1-6 months",
          key: 2,
        },
        {
          value: "6-12 months",
          key: 3,
        },
        {
          value: "1-2 years",
          key: 4,
        },
        {
          value: "More than 2 years",
          key: 5,
        },
      ],
    },
    {
      questionNormal: "When was the",
      questionBold: "last time you trained?",
      key: "lastWorkedOut",

      options: [
        {
          value: "This Week",
          key: 1,
        },
        {
          value: "It's been a month",
          key: 2,
        },
        {
          value: "It's been more than 6 months",
          key: 3,
        },
      ],
    },
    {
      questionNormal: "Do you have any of the following injuries?",
      options: [
        {
          value: "Knee Pain",
          key: "knee_pain",
        },
        {
          value: "Wrist/Fore arm Pain",
          key: "forearm_wrist_pain",
        },
        {
          value: "Neck and Shoulder Pain",
          key: "neck_pain",
        },
        {
          value: "Lower back issues",
          key: "lower_back_pain",
        },
        {
          value: "Ankle Pain",
          key: "ankle_pain",
        },
        {
          value: "None",
          key: "none",
        },
      ],
    },
    {
      questionNormal: "How did you hear about us?",
      key: "refer",
      options: [
        {
          value: "Facebook",
          key: "facebook",
        },
        {
          value: "Instagram",
          key: "instagram",
        },
        {
          value: "Youtube",
          key: "youtube",
        },
        {
          value: "Twitter",
          key: "twitter",
        },
        {
          value: "Friends",
          key: "friends",
        },
        {
          value: "Trainer",
          key: "trainer",
        },
      ],
    },
  ];
  function Question({
    questionNormal,
    questionBold,
    options,
    index,
    answer,
    setAnswer,
  }) {
    return (
      <div className=" flex flex-col">
        <p className="text-lg text-white">
          {questionNormal} <span className="font-bold">{questionBold}</span>
        </p>
        <Popover className={"relative w-full md:w-1/2 mt-5 "}>
          <Popover.Button
            className={`flex flex-row w-full  space-x-2 text-white border-[1px] border-customGray-700 rounded-lg items-center px-5 py-2`}
          >
            <p className="text-xl w-full text-left z-0">
              {answer
                ? options.find((element) => element.key == answer).value
                : "SELECT"}
            </p>
            <Icon
              icon={"akar-icons:chevron-down"}
              className="text-primary-white"
            />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-150"
            enterFrom="opacity-0 translate-y-0"
            enterTo="opacity-100 translate-y-1"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-1"
            leaveTo="opacity-0 translate-y-0"
          >
            <Popover.Panel
              className={`absolute z-50 w-full  -mt-1  p-4 space-y-2 flex flex-col text-[#040405] bg-white rounded-xl`}
            >
              {({ close }) => (
                <>
                  {options.map((option) => {
                    return (
                      <p
                        className="font-bold cursor-pointer"
                        onClick={() => {
                          setAnswer(option.key);
                          close();
                        }}
                      >
                        {option.value}
                      </p>
                    );
                  })}
                </>
              )}
            </Popover.Panel>
          </Transition>
        </Popover>
      </div>
    );
  }

  return (
    <Transition show={true}>
      <Transition.Child
        as={Fragment}
        enter="transform transition ease-in-out duration-300"
        enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leave="transform transition ease-in-out duration-300"
        leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
      >
        <div className="py-10">
          <div className=" grid grid-cols-1 md:grid-cols-2 gap-5 w-full transition-all transform">
            <Question
              {...questions[0]}
              answer={answers[questions[0].key]}
              setAnswer={(answer) => {
                let ans = { ...answers };
                ans[questions[0].key] = answer;
                setAnswers(ans);
              }}
            />
            <Question
              {...questions[1]}
              answer={answers[questions[1].key]}
              setAnswer={(answer) => {
                let ans = { ...answers };
                ans[questions[1].key] = answer;
                setAnswers(ans);
              }}
            />

            <div>
              <p className="text-lg text-white">
                Do you have any of the following injuries?
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                {questions[2].options.map((option) => {
                  return (
                    <div
                      className="cursor-pointer flex flex-row space-x-3 justify-start items-center"
                      onClick={() => {
                        let list = [];
                        if (option.key == "none") {
                          setInjuries(["none"]);
                        } else {
                          injuries.forEach((optionKey) => {
                            if (optionKey != "none") {
                              list.push(optionKey);
                            }
                          });
                          if (list.includes(option.key)) {
                            let l = [];
                            list.forEach((optionKey) => {
                              if (optionKey != option.key) {
                                l.push(optionKey);
                              }
                            });
                            setInjuries([...l]);
                          } else {
                            setInjuries([...list, option.key]);
                          }
                        }
                      }}
                    >
                      <div
                        className={`${
                          injuries.includes(option.key)
                            ? `bg-primary-blue  `
                            : `bg-slate-400`
                        }  rounded-md w-5 h-5 object-cover`}
                      />
                      <p className={`font-medium flex flex-1 text-white`}>
                        {option.value}
                      </p>
                    </div>
                  );
                })}
                {/* <div className="flex flex-col md:flex-row  md:items-center md:space-x-5">
                  <input
                    className="px-4 py-3 md:w-80 rounded-lg border-[1px] placeholder-customGray-700 text-white bg-transparent border-customGray-700 "
                    placeholder="Other Injuries"
                    value={otherInjuries}
                    onChange={(e) => {
                      if (e.target.value == "") {
                        setOtherInjuries("");
                      } else if (e.target.value.match(/^[A-Za-z ]+$/)) {
                        setOtherInjuries(
                          e.target.value
                            .replace(/[^\w\s\][^,\[\]\^]/gi, "")
                            .replace(/[0-9]/g, "")
                        );
                      }
                    }}
                  />
                </div> */}
              </div>
            </div>

            <div className="mt-5 block md:hidden">
              <p className="text-lg text-white">
                When you do,{" "}
                <span className="font-bold">
                  how often do you workout in a week?
                </span>
              </p>
              <div className="md:w-1/2 w-full">
                <Range
                  aria-label="Workout Duration"
                  step={1}
                  min={0}
                  max={7}
                  values={workoutDuration}
                  onChange={(values) => {
                    setWorkoutDuration(values);
                  }}
                  renderTrack={({ props, children }) => (
                    <div
                      {...props}
                      style={{
                        ...props.style,
                        background: getTrackBackground({
                          values: workoutDuration,
                          colors: ["#0B28AC", "#6376CD"],
                          min: 0,
                          max: 7,
                        }),
                        cursor: "pointer",
                      }}
                      className="w-full h-2 mt-12 rounded-full "
                    >
                      {children}
                    </div>
                  )}
                  renderThumb={({ props }) => (
                    <div
                      aria-label="meeting minutes thumb"
                      {...props}
                      style={{
                        ...props.style,
                        outline: "none",
                        cursor: "pointer",
                      }}
                      className={`flex justify-center`}
                    >
                      <p
                        className={`ml-20 font-bold text-center bg-primary-midBlack w-48 rounded-full px-4 py-2 -mt-2 text-white self-center absolute -top-8`}
                      >
                        {numberToWords(workoutDuration[0])}
                        {workoutDuration[0] > 1 ? " Days " : " Day "} a week
                      </p>
                      <span
                        aria-hidden="true"
                        className={`
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                      >
                        <span
                          aria-hidden="true"
                          className={`
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                        />
                      </span>
                    </div>
                  )}
                />
              </div>
            </div>

            <Question
              {...questions[3]}
              answer={answers[questions[3].key]}
              setAnswer={(answer) => {
                let ans = { ...answers };
                ans[questions[3].key] = answer;
                setAnswers(ans);
              }}
            />
          </div>
          <div className="mt-10 hidden md:block">
            <p className="text-lg text-white">
              When you do,{" "}
              <span className="font-bold">
                how often do you workout in a week?
              </span>
            </p>
            <div className="md:w-1/2 w-full">
              <Range
                aria-label="Workout Duration"
                step={1}
                min={0}
                max={7}
                values={workoutDuration}
                onChange={(values) => {
                  setWorkoutDuration(values);
                }}
                renderTrack={({ props, children }) => (
                  <div
                    {...props}
                    style={{
                      ...props.style,
                      background: getTrackBackground({
                        values: workoutDuration,
                        colors: ["#0B28AC", "#6376CD"],
                        min: 0,
                        max: 7,
                      }),
                      cursor: "pointer",
                    }}
                    className="w-full h-2 mt-12 rounded-full "
                  >
                    {children}
                  </div>
                )}
                renderThumb={({ props }) => (
                  <div
                    aria-label="meeting minutes thumb"
                    {...props}
                    style={{
                      ...props.style,
                      outline: "none",
                      cursor: "pointer",
                    }}
                    className={`flex justify-center`}
                  >
                    <p
                      className={`ml-20 font-bold text-center bg-primary-midBlack w-48 rounded-full px-4 py-2 -mt-2 text-white self-center absolute -top-8`}
                    >
                      {numberToWords(workoutDuration[0])}
                      {workoutDuration[0] > 1 ? " Days " : " Day "} a week
                    </p>
                    <span
                      aria-hidden="true"
                      className={`
            pointer-events-none justify-center items-center  inline-flex h-[24px] w-[24px] transform rounded-full bg-primary-white drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] ring-0 transition duration-200 ease-in-out`}
                    >
                      <span
                        aria-hidden="true"
                        className={`
            pointer-events-none inline-block drop-shadow-[0_4px_4px_rgb(0,0,0,0,25)] h-[12px] w-[12px] transform rounded-full bg-white  ring-0 transition duration-200 ease-in-out`}
                      />
                    </span>
                  </div>
                )}
              />
            </div>
          </div>
          <div />
          <div className="flex justify-center space-x-10 md:mt-10 mt-10">
            {/* <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded border-[1px] border-customGray-700 px-5 py-4"
              onClick={() => {
                onClickBack();
              }}
            >
              GO BACK
            </div> */}
            <div className="flex flex-1" />
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-primary-purple px-5 py-4"
              onClick={async () => {
                if (answers.workingOutFrom.length == 0) {
                  toast(
                    "Please share how long have you been training/working out",
                    {
                      type: "error",
                    }
                  );
                } else if (answers.lastWorkedOut.length == 0) {
                  toast("Please share when was the last time you trained", {
                    type: "error",
                  });
                } else if (injuries.length <= 0) {
                  toast("Please share if you have any injuries", {
                    type: "error",
                  });
                } else if (answers.refer.length == 0) {
                  toast("Please share how did you hear about us", {
                    type: "error",
                  });
                } else {
                  onClickNext();
                }
              }}
            >
              FINISH
            </div>
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
}

export function RegistrationStep3({
  wasBackPressed,
  onClickNext,
  onClickBack,
  // onClickSkip,
}) {
  console.log("RENDING STEP 2");
  const navigate = useNavigate();
  return (
    <Transition appear show={true}>
      <Transition.Child
        as={Fragment}
        enter="transform transition ease-in-out duration-300"
        enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leave="transform transition ease-in-out duration-300"
        leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
      >
        <div className={`w-full transform pb-10`}>
          <div className="grid grid-cols-1 md:grid-cols-2 ml-2 mr-2 md:mx-10 md:my-12 md:pl-10 gap-12">
            <div className="col-1 w-full h-full">
              <img src={start} alt="loading" />
              <br />
              <p className="text-sm w-full md:text-base text-white">
                Take the Getactyv Mobility Test to check your current fitness
                level so that we create a well-suited fitness program for you.
              </p>
            </div>
            <div className="col-2 px-0 md:py-20 md:px-10 mx-0 min-w-full">
              <button
                className="flex align-center button bg-[#3E0CA7] text-white text-sm px-5 py-3 rounded-md items-center max-w-max"
                onClick={async () => {
                  onClickNext();
                  // window.skipflag = false;
                }}
              >
                START TEST
              </button>
              {/* <div
                className="max-w-max mt-10 text-white cursor-pointer text-sm rounded-md border-[1px] border-customGray-700 bg-[#282831] px-11 py-2.5"
                onClick={() => {
                  onClickSkip();
                  // toast("Program created");
                  // window.skipflag = true;
                  console.log("skip clicked");
                  // navigate("/programpage");
                }}
              >
                SKIP
              </div> */}
            </div>
          </div>
          <div className="flex justify-center space-x-10 md:px-10 px-2 md:-mt-10">
            <div
              className="max-w-max mt-8 text-white cursor-pointer text-sm rounded border-[1px] border-customGray-700 px-7 md:py-4 py-2.5"
              onClick={() => {
                onClickBack();
              }}
            >
              GO BACK
            </div>
            <div className="flex flex-1" />
            {/* <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded-sm border-[1px] border-customGray-700 bg-[#282831] px-5 py-4"
              onClick={() => {
                onClickSkip();
                // toast("Program created");
                // window.skipflag = true;
                console.log("skip clicked");
                // navigate("/programpage");
              }}
            >
              Skip
            </div> */}
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
}

export function RegistrationStep4({
  // describes,
  // setDescribes,
  wasBackPressed,
  onClickNext,
  onClickBack,
}) {
  console.log("RENDING STEP 2");
  return (
    <Transition appear show={true}>
      <Transition.Child
        as={Fragment}
        enter="transform transition ease-in-out duration-300"
        enterFrom={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
        enterTo={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leave="transform transition ease-in-out duration-300"
        leaveFrom={wasBackPressed ? "translate-x-0" : "translate-x-0"}
        leaveTo={wasBackPressed ? "-translate-x-full" : "translate-x-full"}
      >
        <div className={`w-full transform py-10`}>
          <div className="grid grid-cols-1 md:grid-cols-2 ml-2 mr-2 md:mx-10 md:my-12 md:pl-10 gap-12">
            <div className="col-1 w-full h-full">
              <img src={start} alt="loading" />
              <br />
              <p className="text-sm w-full md:text-base md:w-1/2 text-white">
                Take the Getactyv Mobility Test to check your current fitness
                level so that we create a well-suited fitness program for you.
              </p>
            </div>
            <div className="col-2 px-0 md:py-20 md:px-10 mx-0 min-w-full">
              <button className="flex align-center button bg-[#282831] text-white border-[1px] border-customGray-700 text-sm px-5 py-3 rounded items-center max-w-max">
                <span>
                  <Icon
                    icon="charm:tick"
                    color="#C3F73A"
                    className="h-5 w-5 mr-1"
                  />
                </span>
                COMPLETED
              </button>
            </div>
          </div>
          <div className="flex justify-center space-x-10">
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded-sm border-[1px] border-customGray-700 px-5 py-4"
              onClick={() => {
                onClickBack();
              }}
            >
              GO BACK
            </div>
            <div className="flex flex-1" />
            <div
              className="max-w-max mt-5 text-white cursor-pointer text-sm rounded bg-[#3E0CA7] px-5 py-4"
              onClick={async () => {
                onClickNext();
              }}
            >
              Start Test
            </div>
          </div>
        </div>
      </Transition.Child>
    </Transition>
  );
}

function RegisterPage() {
  const location = useLocation();
  const [step, setStep] = useState(0);
  const [name, setName] = useState(location.state?.fullname);
  const [email, setEmail] = useState(location.state?.email);
  const [mobile, setMobile] = useState(location.state?.phone);
  const [password, setPassword] = useState();
  const [height, setHeight] = useState();
  const [weight, setWeight] = useState();
  const [gender, setGender] = useState();
  const [dob, setDob] = useState();
  const [heightUnit, setHeightUnit] = useState("cm");
  const [weightUnit, setWeightUnit] = useState("KG");
  const [workoutGoal, setWorkoutGoal] = useState([]);
  const [workoutDuration, setWorkoutDuration] = useState([0]);
  const [injuries, setInjuries] = useState([]);
  const [answers, setAnswers] = useState({
    workingOutFrom: "",
    lastWorkedOut: "",
    refer: "",
    injuries: "",
  });
  const [otherInjuries, setOtherInjuries] = useState("");
  const [myHyper, setMyHyper] = useState([]);
  const [createProgram, setCreateProgram] = useState([]);
  // const [coupon, setCoupon] = useState("");
  // const registerThrough = location.state?.registerThrough || "email";
  const [redirectPath, setRedirectPath] = useState();
  const navigate = useNavigate();
  const auth = useAuthContext();
  // window.skipflag = true;

  // Get Goal from the URL
  const urlParams = new URLSearchParams(window.location.search);
  const selectedOption = urlParams.get("selectedOption");
  // setWorkoutGoal(selectedOption);
  // console.log(selectedOption);

  // CREATE-HYPER CUSTOMIZE PROGRAM
  const createHyperPrograms = async () => {
    let detials = {
      goals: selectedOption,
      workingOutFrom: answers.workingOutFrom,
      lastTimeWorkedOut: answers.lastWorkedOut,
      injuries: JSON.stringify(
        injuries.includes("none")
          ? []
          : otherInjuries != ""
          ? [...injuries, otherInjuries]
          : injuries
      ),
    };
    console.log("createHyperPrograms : " + detials);
    // console.log(detials);
    const response = await createHyperProgram(detials);
    console.log("response of hypercustomised program : " + response);
    if (response.success) {
      setCreateProgram(response);
      // toast("Onboarding Successful", { type: "success" });
      setRedirectPath(
        "https://app.getactyvphysio.com/assessment?level=" + response.programLevel
      );
      window.location.href =
        "https://app.getactyvphysio.com/assessment?level=" + response.programLevel;
    }
    //  else if (response.success && window.skipflag == true) {
    //   setCreateProgram(response);
    //   // toast("Onboarding Successful", { type: "success" });
    //   setRedirectPath("https://getactyv.com/programpage");
    //   // window.location.href =
    //   //   "https://http://app.getactyvphysio.com/assessment?level=" + response.programLevel;
    // }
    else {
      toast(response.msg, { type: "error" });
    }
  };

  // HYPER-PROGRAM FOR SKIP BUTTON
  // const createHyperProgramsForSkip = async () => {
  //   console.log("createHyperProgramsForSkip");
  //   let detials = {
  //     goals: workoutGoal[0],
  //     workingOutFrom: answers.workingOutFrom,
  //     lastTimeWorkedOut: answers.lastWorkedOut,
  //     injuries: JSON.stringify(
  //       injuries.includes("none")
  //         ? []
  //         : otherInjuries != ""
  //         ? [...injuries, otherInjuries]
  //         : injuries
  //     ),
  //   };
  //   const response = await createHyperProgram(detials);
  //   if (response.success) {
  //     setCreateProgram(response);
  //     setRedirectPath("https://http://app.getactyvphysio.com/programpage");
  //     window.location.href = "https://http://app.getactyvphysio.com/programpage";
  //     toast("Program Created ", { type: "success" });
  //   } else {
  //     toast(response.msg, { type: "error" });
  //   }
  // };

  const [showCuratingDialog, setShowCurationDialog] = useState(false);
  const [wasBackPressed, setWasBackPressed] = useState(false);
  const [open, setOpen] = useState(false);
  return (
    <div
      className={`font-open-sans w-full h-full px-6  py-20 md:px-16 lg:px-24 2xl:px-32 `}
      id="register"
    >
      <InstructionDialog
        show={open}
        close={() => {
          setOpen(false);
        }}
        // redirectUrl={`${window.location.origin}/programpage`}
        // redirectUrl={`https://testing.getactyv.com/assessment?level=moderate`}
        redirectUrl={redirectPath}
      />
      <CuratingPlaylist show={showCuratingDialog} closeDialog={() => {}} />
      <div className="bg-white bg-opacity-5 rounded-lg overflow">
        <div
          className="px-6 md:px-14 md:pt-10 pt-6 bg-no-repeat overflow"
          // style={{ backgroundImage: `url(${healthyLife})` }}
        >
          <p className="font-poppins text-white font-bold text-3xl md:text-4xl leading-snug">
            <span className="text-primary-neonGreen">Customise </span> your
            program
          </p>
          <p className={`text-white text-opacity-70 mt-2 text-lg font-medium `}>
            Tell us more about you
          </p>

          {/* <Stepper maxStep={2} currentStep={step} /> */}
        </div>
        <div className="px-6 md:px-14">
          {step == 0 && (
            // <RegistrationStep1
            //   wasBackPressed={wasBackPressed}
            //   describes={workoutGoal}
            //   setDescribes={setWorkoutGoal}
            //   onClickNext={() => {
            //     setWasBackPressed(false);
            //     document
            //       .getElementById("register")
            //       .scrollIntoView({ behavior: "smooth" });
            //     setStep(1);
            //   }}
            //   onClickBack={() => {
            //     setWasBackPressed(true);
            //     document
            //       .getElementById("register")
            //       .scrollIntoView({ behavior: "smooth" });
            //     setStep(0);
            //   }}
            // />
            <RegistrationStep2
              answers={answers}
              setAnswers={setAnswers}
              injuries={injuries}
              setInjuries={setInjuries}
              workoutDuration={workoutDuration}
              setWorkoutDuration={setWorkoutDuration}
              otherInjuries={otherInjuries}
              setOtherInjuries={setOtherInjuries}
              onClickNext={() => {
                setWasBackPressed(false);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(1);
              }}
              // onClickBack={() => {
              //   setWasBackPressed(true);
              //   document
              //     .getElementById("register")
              //     .scrollIntoView({ behavior: "smooth" });
              //   setStep(0);
              // }}
            />
          )}

          {step == 1 && (
            // <RegistrationStep2
            //   answers={answers}
            //   setAnswers={setAnswers}
            //   injuries={injuries}
            //   setInjuries={setInjuries}
            //   workoutDuration={workoutDuration}
            //   setWorkoutDuration={setWorkoutDuration}
            //   otherInjuries={otherInjuries}
            //   setOtherInjuries={setOtherInjuries}
            //   onClickNext={() => {
            //     setWasBackPressed(false);
            //     document
            //       .getElementById("register")
            //       .scrollIntoView({ behavior: "smooth" });
            //     setStep(2);
            //   }}
            //   onClickBack={() => {
            //     setWasBackPressed(true);
            //     document
            //       .getElementById("register")
            //       .scrollIntoView({ behavior: "smooth" });
            //     setStep(0);
            //   }}
            // />
            <RegistrationStep3
              wasBackPressed={wasBackPressed}
              // describes={workoutGoal}
              // setDescribes={setWorkoutGoal}
              onClickNext={() => {
                createHyperPrograms();
              }}
              onClickBack={() => {
                setWasBackPressed(true);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(0);
              }}
              // onClickSkip={() => {
              //   createHyperProgramsForSkip();
              // }}
            />
          )}

          {/* {step == 2 && (
            <RegistrationStep4
              wasBackPressed={wasBackPressed}
              onClickNext={() => {
                navigate("/programpage");
              }}
              onClickBack={() => {
                setWasBackPressed(true);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(2);
              }}
            />
            <RegistrationStep3
              wasBackPressed={wasBackPressed}
              describes={workoutGoal}
              setDescribes={setWorkoutGoal}
              onClickNext={() => {
                //  setOpen(true)
                // setWasBackPressed(false);
                createHyperPrograms();
                // navigate("/programpage");
                // document
                //     .getElementById("register")
                //     .scrollIntoView({ behavior: "smooth" });
                //     createHyperPrograms();
                // if(createProgram.success){
                //     document
                //     .getElementById("register")
                //     .scrollIntoView({ behavior: "smooth" });
                // setStep(3);

                // }
              }}
              onClickBack={() => {
                setWasBackPressed(true);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(1);
              }}
              onClickSkip={() => {
                createHyperProgramsForSkip();
              }}
            />
          )} */}

          {/* {step == 3 && (
            <RegistrationStep4
              wasBackPressed={wasBackPressed}
              onClickNext={() => {
                navigate("/programpage");
              }}
              onClickBack={() => {
                setWasBackPressed(true);
                document
                  .getElementById("register")
                  .scrollIntoView({ behavior: "smooth" });
                setStep(2);
              }}
            />
          )} */}
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
